<template>
 <div>
  <div
       :class="{'cursor-pointer': !item.editing, 'active': item.editing}"
       class="promptLine border-b border-[#8A8A8A] tw-flex items-center gap-2 px-[16px] grid grid-cols-[minmax(0,051fr)_minmax(0,6fr)_minmax(0,2fr)_minmax(0,025fr)]"
       @click="setShowAnswers(item)"
  >
    <div class=" py-[12px]">

    </div>
    <div class="text-13 font-semibold tw-flex">
      <div class="tw-flex items-center gap-2 p-[5px] flex-1"
           :class="{'boxEditingPrompt':item.editing}"
      >
              <textarea class="flex-1 outline-transparent"
                        @click="setShowAnswers(item)"
                        :class="{'text-[#8367DF]': item.edited, 'cursor-pointer': !item.editing}"
                        :readonly="!item.editing"
                        v-model="item.text"></textarea>
        <div :class="{'hidden': !item.editing, 'tw-flex items-center': item.editing}">
          <button class="tw-flex items-center" @click.stop="$emit('onSave',item)">
            <img src="@/assets/img/IAReputation/applyChange.svg" />
          </button>
        </div>
        <div v-if="item.type === 'sectoral'" class="dimension" :class="`dimension${dimensions.findIndex(e => e == item.dimension) + 1}`">{{ item.dimension }}</div>
      </div>

    </div>
    <div class="border-l border-r border-[#EEEEEE] self-stretch py-[12px] px-[16px]">
      <slot></slot>
    </div>
    <div class="text-center relative">
      <button v-if="!isProcessing && canEditPrompt" @click.stop="item.showMenu = !item.showMenu" class="p-[10px]">
        <img src="@/assets/img/IAReputation/PointsMenu.svg" class="min-w-[4px]" />
      </button>
      <OptionsEditPrompt
        :show="item.showMenu"
        @update:show="item.showMenu = $event"
        :prompt="item.text"
        @onEdit="item.editing = true"
        @onDelete="showConfirmDeletePrompt = true"
      ></OptionsEditPrompt>
    </div>


  </div>
  <ModalQuestion :data="data" :question="dataQuestion" :show="showQuestion" @update:show="showQuestion = $event"></ModalQuestion>
   <ModalConfirmDeletePrompt
       :show="showConfirmDeletePrompt"
       @update:show="showConfirmDeletePrompt = $event"
       @onConfirmDelete="$emit('onConfirmDelete', $event)"
   ></ModalConfirmDeletePrompt>
  </div>
</template>
<script>
import OptionsEditPrompt from "@/components/IAReputation/OptionsEditPrompt.vue"
import MixinIAReputation from "@/mixins/iareputation.js"
import ModalQuestion from "@/components/IAReputation/ModalQuestion.vue"
import ModalConfirmDeletePrompt from "@/components/IAReputation/ModalConfirmDeletePrompt.vue"
export default {
  components: {OptionsEditPrompt, ModalQuestion, ModalConfirmDeletePrompt},
  props: ['item', 'data','isProcessing'],
  mixins: [MixinIAReputation],
  data() {
    return {
      dataQuestion: null,
      showQuestion: false,
      showConfirmDeletePrompt: false,
    }
  },
  computed: {
    canEditPrompt () {
      return this.$store.getters.getUserInfo?.change_IA_prompt
    }
  },
  methods: {
    setShowAnswers (item) {
      if (!item.editing && !item.edited) {
        this.dataQuestion = item.text
        this.showQuestion = true
      }
    }
  }
}
</script>
<style scoped>
.min-w-\[4px\]{
min-width: 4px;
}
textarea {
  resize: none; /* Esto deshabilita la funcionalidad de redimensionar */
}
.promptLine{
  &:hover{
  background-color: #EFEDF8;}
  &.active{
    background-color: #EFEDF8;

  }
}
</style>
